// Set some constants to refer to elements on the page
const headings              = document.querySelectorAll( '.wp-block-biro-h2' );
const headingBackWrapper    = document.querySelector( '#heading-back-wrapper' );
const inPageNavToggle       = document.querySelector( '#in-page-nav-toggle' );
const inPageNavListWrapper  = document.querySelector( '#in-page-nav-list-wrapper' );
const inPageNavListDropdown = document.querySelector( '#in-page-nav-list-dropdown' );
const inPageNavListInline   = document.querySelector( '#in-page-nav-list-inline' );
const mobileHeader          = document.querySelector( '#header-mobile' );

// If there is a toggle
if ( inPageNavToggle !== null ) {

  // Loop through the headings
  headings.forEach( function( heading ) {

    // Set tabindex to -1 for screen readers
    heading.setAttribute( 'tabindex', '-1' );

    // Get the heading text
    let heading_text = heading.innerHTML;

    // Construct the ID by:
    //  replacing everything except alphanumeric characters, dashes and spaces,
    //  converting to lower case,
    //  and replacing spaces with dashes.
    let heading_id = encodeURIComponent( heading_text.replace( /[^0-9A-Z\-\s]+/gi, '' ).toLowerCase().replaceAll( ' ', '-' ) );

    // Set the ID on the heading
    heading.setAttribute( 'id', heading_id );

    // Add the item to both lists, with -1 tabindex on dropdown to stop keyboard users seeing the nav twice
    inPageNavListInline.innerHTML += '<li class="item"><a class="link" href="#' + heading_id + '">' + heading_text + '</a></li>';
    inPageNavListDropdown.innerHTML += '<li class="item"><a class="link" href="#' + heading_id + '" tabindex="-1">' + heading_text + '</a></li>';

  } );

  // Declare the newly-written inPageNavLinks
  const inPageNavLinks = document.querySelectorAll( '#in-page-nav-list-dropdown .link, #in-page-nav-list-inline .link' );

  // Loop through the links
  inPageNavLinks.forEach( function( link ) {

    // Add an event listener for a click
    link.addEventListener( 'click', function( event ) {

      // Stop the link being followed so we can control the scroll
      event.preventDefault();

      // Hide the menu
      inPageNavListWrapper.style.display = 'none';

      // Flag that the menu is not expanded
      inPageNavToggle.classList.remove( 'is-active' );

      // Get the href of the clicked link
      let linkHref = event.currentTarget.getAttribute( 'href' );

      // Scroll to that point
      scrollToHash( linkHref );

      // Add the URL hash
      window.history.pushState( {}, '', window.location.origin + window.location.pathname + linkHref );

    } );

  } );

  // Set a debounce timer variable
  let debounce_timer = true;

  // When the window scrolls
  window.onscroll = function() {

    // If there's a debounce time already in operation
    if( debounce_timer ) {

      // Clear the timeout
      window.clearTimeout( debounce_timer );

      // Set a function to run after a timeout
      debounce_timer = window.setTimeout( function() {

        // If the bottom of the heading / back wrapper is further down the page than the top of the inline list
        if ( headingBackWrapper.getBoundingClientRect().bottom > inPageNavListInline.getBoundingClientRect().bottom ) {

          // Mark the header bar as active
          headingBackWrapper.classList.add( 'is-active' );

        // Otherwise the bottom of the header / back wrapper is above the top of the inline list
        } else {

          // Mark the header bar as inactive
          headingBackWrapper.classList.remove( 'is-active' );

          // Hide the menu
          inPageNavListWrapper.style.display = 'none';

          // Flag that the menu is not expanded
          inPageNavToggle.classList.remove( 'is-active' );

        }

        // Loop through the links in the dropdown
        document.querySelectorAll( '#in-page-nav-list-dropdown a' ).forEach( function( element ) {

          // Remove any current classes
          element.classList.remove( 'current' );

        } );

        // Create a variable for last heading tested
        let lastHeading = false;

        // Loop through the headings on the page
        headings.forEach( function( heading ) {

          // If the top of the heading heading is more than halfway up the page
          if ( heading.getBoundingClientRect().top < ( window.innerHeight / 2 ) ) {

            // Set the lastHeading tested to this one
            lastHeading = heading;

          }

        } );

        // If there's a heading (there might not be when scrolling to the top)
        if ( lastHeading ) {

          // Add the 'current' class to the matching list item link
          document.querySelector( '#in-page-nav-list-dropdown li a[ href="#' + lastHeading.getAttribute( 'id' ) + '" ]' ).classList.add( 'current' );

        }

      }, 100 );
    }
  };

  // Add an event listener on the toggle
  inPageNavToggle.addEventListener( 'click', function( event ) {

    // If the menu isn't expanded
    if ( ! inPageNavToggle.classList.contains( 'is-active' ) ) {

      // Define the max height as the window height
      navMaxHeight = window.innerHeight;

      // Remove the height of the mobile header
      navMaxHeight -= mobileHeader.getBoundingClientRect().height;

      // Remove the height of the content header
      navMaxHeight -= headingBackWrapper.getBoundingClientRect().height;

      // If the admin bar is there
      if ( adminBar = document.querySelector( '#wpadminbar' ) ) {

        // Remove the height of the admin bar
        navMaxHeight -= adminBar.getBoundingClientRect().height;

      }

      // Set the max-height property
      // +1 is for a border somewhere
      inPageNavListWrapper.style.maxHeight = ( navMaxHeight + 1 ) + 'px';

      // Display it
      inPageNavListWrapper.style.display = 'block';

      // Flag that the menu is expanded
      inPageNavToggle.classList.add( 'is-active' );

    // Otherwise the menu is expanded
    } else {

      // Hide the menu
      inPageNavListWrapper.style.display = 'none';

      // Flag that the menu is not expanded
      inPageNavToggle.classList.remove( 'is-active' );

    }

  } );

}
